import { defineCustomElements } from '@ionic/pwa-elements/loader';
import ReactDOM from 'react-dom';
import App from './App';
import { MessageContextProvider } from './contexts/MessageContext';
import * as serviceWorker from './serviceWorker';

ReactDOM.render(
	<MessageContextProvider>
		<App />
	</MessageContextProvider>,
	document.getElementById('root')
);

// O cardápio funciona online; retire somente o worker antigo deste aplicativo.
void serviceWorker.unregister();

defineCustomElements(window);